import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import StringInput from './StringInput';

export default class TextareaInput extends StringInput {
  constructor (props, context) {
    super(props, context);
    this.attributes = Object.assign(this.attributes, {
      rows: this.rows,
    });
  }

  get rows () {
    return this.fromPropsOrContext('rows');
  }

  get inputTag () {
    return 'textarea';
  }

  get inputType () {
    return '';
  }
}

mergeStaticOptions(TextareaInput, {
  propTypes: {
    rows: PropTypes.number,
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/TextareaInput.jsx